import SupportRequestsTable from './SupportRequestsTable';

export default SupportRequestsTable;
